// extracted by mini-css-extract-plugin
export default {"wrapper":"button-v2_wrapper__yuRjP","black":"button-v2_black__KHntE","full":"button-v2_full__-Udog","feedback-inactive":"button-v2_feedback-inactive__aPSUB"};